import { makeStyles } from "@material-ui/core/styles";

export const resetPasswordPageStyle = makeStyles(() => ({
  formContainer: {
    backgroundColor: "#FCF9FA",
    border: "1px solid #DDDDDD",
    boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.1)",
    borderRadius: "8px",
    padding: "2rem 3rem",
    width: "45%",
    margin: "auto",
    marginTop: "8rem",
    color: "#505050",
  },
  resetP: {
    color: "#333333",
    fontWeight: "bold",
    fontSize: "1.25rem",
    marginBottom: "10px",
  },
  inputSection: {
    margin: "1.5rem 0rem",
  },
  formLabel: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid #E6072C",
    borderRadius: "4px",
  },
  formInput: {
    border: "1px solid #808080",
    borderRadius: "4px",
    padding: "0.5rem",
    width: "100%",
    backgroundColor: "transparent",
    outline: "none",
  },
  submitform: {
    backgroundColor: "#E6072C",
    borderRadius: "4px",
    textAlign: "center",
    color: "#FCF9FA",
    width: "100%",
    padding: "0.5rem 0rem",
  },
}));
